"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
const config = {
  dev: {
    env: 'dev',
    getLayoutUrl: (hostname, plid) => `https://content.dev-${hostname}/pl/${plid}/product/configure?`,
    getBasketUrl: hostname => `https://cart.dev-${hostname}/go/checkout`,
    getDppUrl: hostname => `https://www.dev-${hostname}/dpx/registration`
  },
  test: {
    env: 'test',
    getLayoutUrl: (hostname, plid) => `https://content.test-${hostname}/pl/${plid}/product/configure?`,
    getBasketUrl: hostname => `https://cart.test-${hostname}/go/checkout`,
    getDppUrl: hostname => `https://www.test-${hostname}/dpx/registration`
  },
  prod: {
    env: 'prod',
    getLayoutUrl: (hostname, plid) => `https://content.${hostname}/pl/${plid}/product/configure?`,
    getBasketUrl: hostname => `https://cart.${hostname}/go/checkout`,
    getDppUrl: hostname => `https://www.${hostname}/dpx/registration`
  }
};
var _default = exports.default = config;